module.exports = __webpack_public_path__ + "img/badge-most-appointment-keyvue-blue.3934bf9d.png";